import AuthService from './AuthService';

export const auth = new AuthService();

function makePayload(params){
  const {
    answers,
    deviceType,
    contactData,
    form,
    store_key,
    userContext,
    url_from
  } = params;

  const response = {
    deviceType,
    contactData,
    form,
    user_context: userContext,
    url_from
  }
  if (answers) {
    const firstEntry = answers[0];
    if (firstEntry) Object.assign(response, {
      encuesta_id: firstEntry.encuesta,
      punto_de_venta_id: firstEntry.b,
      mail: firstEntry.mail,
      store_key:store_key,
      telefono: firstEntry.telefono,
      referral: firstEntry.referral,
      usuario_final_id: firstEntry.usuario_final_id,
      is_first_visit: firstEntry.is_first_visit,
      comment: firstEntry.comentario,
      answers: [],
    });

    response.answers = answers.map((entry) => {
      const find = response.answers.find((answer) => answer.pregunta_id === entry.pregunta);
      const answer = find || {
        pregunta_id: entry.pregunta,
        voto_id: entry.v,
        score: entry.score,
        comment: entry.comment,
        motives: [],
        src: entry.src,
      };
      answer.motives.push(entry.motivo);
      return answer;
    });
  } else {
    return;
  }



  return response;
}

const Smilehelper = {
  getData: function(params) {
    return auth.get(DATOS_GET, params);
  },
  getStores: function(hash,authorization) {
    if (authorization) auth.setHeaders({
      'Authorization': authorization,
    });
    return auth.get(`api/form-data/${hash || ''}/stores`);
  },
  getFormData: function({ hash, authorization }) {
    if (authorization) auth.setHeaders({
      'Authorization': authorization,
    });
    return auth.get(`api/form-data/${hash || ''}`);
  },
  postEventData({ payload }) {
    return auth.post('apiv3/rest/eventsContacts', payload);
  },
  updateFeedback: function(params) {
    const response = makePayload(params);
    const {hash,feedbackId} = params;
    if (hash) return auth.patch(`api/form-data/${hash}`, {
      feedbackId,
      data: response,
    });
  },
  postDatos: function(params) {
    const response = makePayload(params);
    const {hash, deviceType} = params;

    if (hash) return auth.post(`api/form-data/${hash}`, {
      data: response,
    });

    return auth.post(DATOS_POST, {
      deviceType,
      data: response,
    });

  },
  postFile(payload) {
    return auth.post('api/form-data/validate-file', payload, 'more-info');
  }
};
const DATOS_GET = 'api/infoQr';
const DATOS_POST = 'apiv3/rest/votosEmpresas';
export default Smilehelper;
